(function () {
  try {
    var path = location.pathname || "";
    if (!/^\/de(\/|$)/i.test(path)) return;
    var dest = "/de/products/foto-kunstposter";
    var zombies = [
      "/de/products/poster-personalisieren",
      "/de/products/personalisiertes-poster",
      "/de/products/affiche-personnalisee",
      "/de/products/foto-als-kunstposter"
    ];
    if (zombies.indexOf(path) !== -1) {
      location.replace(dest + (location.search || "") + (location.hash || ""));
    }
  } catch (e) {}
})();
